import { Table as TableJoy } from "@mui/joy";

interface Props {
    children: React.ReactNode;
    minWidth?: string;
    minHeight?: string;
}

export function Table({ children, minWidth, minHeight }: Props) {
    return (
        <TableJoy
            stickyHeader
            sx={() => ({
                minWidth: minWidth,
                minHeight: minHeight,
                "th": { bgcolor: "#111827", color: "#ffffff" },
            })}>
            {children}
        </TableJoy>
    );
}
